import React, { PureComponent } from "react";

export class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="end"
          fill="#666"
          transform="rotate(-35)"
        >
          {payload.value}
        </text>
      </g>
    );
  }
}

const ICON_SIZE = 20;
const ICON_SPACING = 2;

const WARNING_ICON_SIZE = 28;
const WARNING_ICON_VIEWBOX = "-2 0 34 32";
const WARNING_ICON_SHIFT = 4;
const IMPACT_VISUAL_OFFSET_Y = 3;
const OPEN_VISUAL_OFFSET_Y = 1;

const ALERT_ICON_PATH =
  "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z";

const IMPACT_ICON_PATHS = [
  "M17 22.1601V12.3231L18 12.1241V15.5041C18 15.8121 18.143 16.1031 18.386 16.2931C18.562 16.4311 18.779 16.5041 19 16.5041C19.082 16.5041 19.164 16.4941 19.244 16.4731L23.244 15.4651C23.688 15.3521 24 14.9531 24 14.4951V10.9241L25 10.7231V19.7601L17 22.1601ZM9 9.94706L15 12.1971V22.0561L9 19.8101V9.94706ZM16.997 7.56306L22.106 9.26306L16.084 10.4681L11.525 8.75806L16.997 7.56306ZM20 11.7231L22 11.3231V13.7161L20 14.2211V11.7231ZM26.983 9.41806C26.976 9.33206 26.962 9.24906 26.933 9.16906C26.917 9.12606 26.897 9.08806 26.877 9.04806C26.842 8.98006 26.801 8.92006 26.751 8.86206C26.722 8.82706 26.693 8.79506 26.659 8.76406C26.603 8.71306 26.538 8.67406 26.47 8.63706C26.431 8.61506 26.396 8.59106 26.354 8.57506C26.341 8.57006 26.33 8.55906 26.315 8.55506L17.367 5.57906C17.196 5.52406 17.014 5.51306 16.839 5.55206L7.787 7.52706C7.751 7.53506 7.721 7.55606 7.687 7.56706C7.642 7.58206 7.6 7.59706 7.559 7.61706C7.487 7.65306 7.424 7.69806 7.364 7.74906C7.333 7.77406 7.302 7.79506 7.274 7.82306C7.198 7.90406 7.136 7.99506 7.091 8.09706C7.087 8.10406 7.081 8.10906 7.078 8.11606C7.037 8.21506 7.011 8.32106 7.003 8.43106C7.002 8.44506 7.007 8.45806 7.007 8.47206C7.006 8.48306 7 8.49206 7 8.50406V20.5041C7 20.9211 7.259 21.2941 7.649 21.4401L15.646 24.4321C15.76 24.4751 15.878 24.5041 16 24.5041C16.097 24.5041 16.193 24.4901 16.287 24.4621L26.287 21.4621C26.71 21.3351 27 20.9451 27 20.5041V9.50406C27 9.47306 26.985 9.44806 26.983 9.41806Z",
  "M8.66243 4.70936L8.13713 0.971617C8.05164 0.363354 7.53862 -0.067964 6.99199 0.00885957C6.44536 0.0856831 6.0711 0.6417 6.15659 1.24996L6.6819 4.98771C6.76738 5.59597 7.2804 6.02729 7.82703 5.95047C8.37366 5.87364 8.74792 5.31763 8.66243 4.70936Z",
  "M2.0459 4.30283L4.76103 6.9248C5.20288 7.35149 5.87269 7.37552 6.25615 6.97845C6.6396 6.58137 6.5922 5.91281 6.15035 5.48612L3.43522 2.86415C2.99337 2.43746 2.32356 2.41342 1.94011 2.8105C1.55666 3.20757 1.60405 3.87614 2.0459 4.30283Z",
  "M11.2803 5.69875L13.391 2.56956C13.7345 2.06033 13.6418 1.39653 13.1842 1.08785C12.7266 0.779177 12.0764 0.941948 11.7329 1.45118L9.62225 4.58036C9.27877 5.0896 9.37141 5.7534 9.82904 6.06208C10.2867 6.37075 10.9368 6.20798 11.2803 5.69875Z",
  "M3.07581 14.0193L6.12943 11.8008C6.62636 11.4397 6.76634 10.7843 6.44189 10.3377C6.11743 9.8911 5.45079 9.82168 4.95386 10.1827L1.90024 12.4013C1.40331 12.7624 1.26333 13.4178 1.58779 13.8644C1.91224 14.311 2.57888 14.3804 3.07581 14.0193Z",
  "M1.11276 9.52866H4.88724C5.50148 9.52866 6 9.08066 6 8.52866C6 7.97666 5.50148 7.52866 4.88724 7.52866H1.11276C0.498516 7.52866 0 7.97666 0 8.52866C0 9.08066 0.498516 9.52866 1.11276 9.52866Z",
];

const OPEN_ICON_PATHS = [
  "M10 24.0927V14.2557L11 14.0567V17.4367C11 17.7447 11.143 18.0357 11.386 18.2257C11.562 18.3637 11.779 18.4367 12 18.4367C12.082 18.4367 12.164 18.4267 12.244 18.4057L16.244 17.3977C16.688 17.2847 17 16.8857 17 16.4277V12.8567L18 12.6557V21.6927L10 24.0927ZM2 11.8797L8 14.1297V23.9887L2 21.7427V11.8797ZM9.997 9.49572L15.106 11.1957L9.084 12.4007L4.525 10.6907L9.997 9.49572ZM13 13.6557L15 13.2557V15.6487L13 16.1537V13.6557ZM19.983 11.3507C19.976 11.2647 19.962 11.1817 19.933 11.1017C19.917 11.0587 19.897 11.0207 19.877 10.9807C19.842 10.9127 19.801 10.8527 19.751 10.7947C19.722 10.7597 19.693 10.7277 19.659 10.6967C19.603 10.6457 19.538 10.6067 19.47 10.5697C19.431 10.5477 19.396 10.5237 19.354 10.5077C19.341 10.5027 19.33 10.4917 19.315 10.4877L10.367 7.51172C10.196 7.45672 10.014 7.44572 9.839 7.48472L0.787 9.45972C0.751 9.46772 0.721 9.48872 0.687 9.49972C0.642 9.51472 0.6 9.52972 0.559 9.54972C0.487 9.58572 0.424 9.63072 0.364 9.68172C0.333 9.70672 0.302 9.72772 0.274 9.75572C0.198 9.83672 0.136 9.92772 0.091 10.0297C0.087 10.0367 0.081 10.0417 0.078 10.0487C0.037 10.1477 0.011 10.2537 0.003 10.3637C0.002 10.3777 0.007 10.3907 0.007 10.4047C0.006 10.4157 0 10.4247 0 10.4367V22.4367C0 22.8537 0.259 23.2267 0.649 23.3727L8.646 26.3647C8.76 26.4077 8.878 26.4367 9 26.4367C9.097 26.4367 9.193 26.4227 9.287 26.3947L19.287 23.3947C19.71 23.2677 20 22.8777 20 22.4367V11.4367C20 11.4057 19.985 11.3807 19.983 11.3507Z",
  "M16.0975 2.0789L22.2542 4.19882C23.2561 4.54381 24.2151 4.40021 24.3949 3.87828C24.5746 3.35635 23.9073 2.65277 22.9054 2.30778L16.7487 0.187861C15.7467 -0.157126 14.7877 -0.0135238 14.608 0.508402C14.4283 1.03033 15.0956 1.73391 16.0975 2.0789Z",
  "M19.9413 11.2384L23.8501 5.44335C24.4862 4.50028 24.6311 3.48437 24.1735 3.1757C23.7158 2.86702 22.8282 3.38189 22.1921 4.32496L18.2832 10.1201C17.6471 11.0631 17.5023 12.079 17.9599 12.3877C18.4175 12.6964 19.3052 12.1815 19.9413 11.2384Z",
  "M11.7452 7.78828L15.4328 2.32127C16.0328 1.43159 16.1485 0.459015 15.6908 0.150341C15.2332 -0.158334 14.3748 0.313207 13.7747 1.20289L10.0871 6.6699C9.48703 7.55958 9.37141 8.53215 9.82904 8.84083C10.2867 9.1495 11.1451 8.67796 11.7452 7.78828Z",
];

export const AlertIcon = ({ x, y, fill }) => (
  <svg
    x={x}
    y={y}
    width={ICON_SIZE}
    height={ICON_SIZE}
    fill={fill}
    viewBox="64 64 896 896"
  >
    <path d={ALERT_ICON_PATH} />
  </svg>
);

export const ImpactIcon = ({ x, y, fill }) => (
  <svg
    x={x - WARNING_ICON_SHIFT}
    y={y - WARNING_ICON_SHIFT}
    width={WARNING_ICON_SIZE}
    height={WARNING_ICON_SIZE}
    viewBox={WARNING_ICON_VIEWBOX}
    fill={fill}
  >
    <g transform="translate(-1 2)">
      {IMPACT_ICON_PATHS.map((d, i) => (
        <path key={i} fillRule="evenodd" clipRule="evenodd" d={d} />
      ))}
    </g>
  </svg>
);

export const OpenIcon = ({ x, y, fill }) => (
  <svg
    x={x - WARNING_ICON_SHIFT}
    y={y - WARNING_ICON_SHIFT}
    width={WARNING_ICON_SIZE}
    height={WARNING_ICON_SIZE}
    viewBox={WARNING_ICON_VIEWBOX}
    fill={fill}
  >
    <g transform="translate(6 0)">
      {OPEN_ICON_PATHS.map((d, i) => (
        <path key={i} fillRule="evenodd" clipRule="evenodd" d={d} />
      ))}
    </g>
  </svg>
);

export const CustomizedDot = ({ cx, cy, payload }) => {
  const hasTempAlert = payload?.hasTempAlertDot;
  const hasImpactAlert = payload?.hasImpactAlertDot;
  const hasOpenAlert = payload?.hasOpenAlertDot;

  if (!hasTempAlert && !hasImpactAlert && !hasOpenAlert) return null;

  const halfIcon = ICON_SIZE / 2;
  const xPos = cx - halfIcon;

  // Posiciones fijas tipo semáforo vertical
  const tempY = cy - halfIcon;
  const impactY = tempY - ICON_SIZE - ICON_SPACING + IMPACT_VISUAL_OFFSET_Y;
  const openY = tempY + ICON_SIZE + ICON_SPACING + OPEN_VISUAL_OFFSET_Y;

  return (
    <g>
      {hasImpactAlert && <ImpactIcon x={xPos} y={impactY} fill="#002E6D" />}
      {hasTempAlert && <AlertIcon x={xPos} y={tempY} fill="red" />}
      {hasOpenAlert && <OpenIcon x={xPos} y={openY} fill="#002E6D" />}
    </g>
  );
};

export const CustomizedTooltip = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) return null;

  const data = payload[0].payload;
  const isTempAndHumidityNaN = isNaN(data.temp) && isNaN(data.humidity);

  const events = Array.isArray(data.events)
    ? data.events
    : data.isEvent
      ? [
          {
            name: data.name,
            eventDate: data.eventDate,
            ref: data.ref,
          },
        ]
      : [];

  return (
    <div className="custom-tooltip">
      <p>{data.date}</p>

      {isTempAndHumidityNaN ? (
        events.length > 0 ? (
          <>
            {events.map((ev) => (
              <p key={`${ev.ref || ev.name}-${ev.eventDate}`}>
                {ev.name}
                {ev.eventDate ? ` - ${ev.eventDate}` : ""}
              </p>
            ))}
          </>
        ) : null
      ) : (
        <>
          {typeof data.temp === "number" && !isNaN(data.temp) && (
            <p className="temp">{`Temperatura: ${data.temp.toFixed(2)}°C`}</p>
          )}

          {typeof data.humidity === "number" && !isNaN(data.humidity) && (
            <p className="hum">{`Humedad: ${data.humidity.toFixed(2)}%`}</p>
          )}

          {events.length > 0 && (
            <>
              {events.map((ev) => (
                <p key={`${ev.ref || ev.name}-${ev.eventDate}`}>
                  {ev.name}
                  {ev.eventDate ? ` - ${ev.eventDate}` : ""}
                </p>
              ))}
            </>
          )}
        </>
      )}
    </div>
  );
};
